export var isAvailableForNotifications = function isAvailableForNotifications() {
  var _window;
  return ((_window = window) === null || _window === void 0 || (_window = _window.Notification) === null || _window === void 0 ? void 0 : _window.permission) === 'granted';
};
export var requestNotificationPermission = function requestNotificationPermission() {
  var _window2;
  if ((_window2 = window) !== null && _window2 !== void 0 && _window2.Notification) {
    return window.Notification.requestPermission();
  }
  return false;
};